import React from 'react';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import styles from './IntegrationDetailPageShell.module.scss';

/**
 * Shared shell for all integration detail pages.
 * Renders back button, logo, title/subtitle, and wraps children in the panels container.
 */
export const IntegrationDetailPageShell = ({
  logoText,
  logoColor,
  title,
  subtitle,
  children,
}) => {
  const history = useHistory();

  return (
    <div className={styles.page}>
      <button
        className={styles.backBtn}
        onClick={() => history.push(appRoutes().integrations)}
      >
        ← Back to Integrations
      </button>

      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.logoMark} style={{ background: logoColor }}>
            {logoText}
          </div>
          <div className={styles.titleBlock}>
            <Text
              variant={textVariantsEnum.Header}
              fontWeight={fontWeightEnum.Semibold}
            >
              {title}
            </Text>
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Normal}
              color="gray-600"
            >
              {subtitle}
            </Text>
          </div>
        </div>
      </div>

      <div className={styles.panels}>{children}</div>
    </div>
  );
};
